module.exports = __webpack_public_path__ + "media/images/estacao_meteorologica-2477a60e10ba9ffe66a2c6043b5fdc29.png";